import React, { useState } from "react";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Typography } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  setStorageItem,
} from "../../../helpers/utils";
import { postWebService } from "../../../helpers/server";
import { useHistory } from "react-router";

function BuyflowPaymentFailed({
  classes: { containerButton, main, loaderBox },
}) {
  const history = useHistory();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);

  const handleRetryPayment1 = () => {
    const oid = getStorageItem("oid");
    setStorageItem("paymentretry" + oid, "1");
    navigateTo(getRoute("payment"));
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const handleRetryPayment = async () => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService("retry-payment.php", {
        oid: Number(localStorage.getItem("oid")),
      });

      setIsFormSubmitted(false);
      const { code } = response.data;

      code == 200
        ? navigateTo(getRoute("payment"))
        : navigateTo(getRoute("payment"));
    } catch (error) {
      cbError(error);
    }
  };

  const cbError = (error) => setIsFormSubmitted(false);

  return isLoaded ? (
    <Box className={main}>
      <Box display="flex" justifyContent="center" ml={0} mr={0} mt={3} mb={3}>
        <SectionTitle title={"Payment Failed"} />
      </Box>

      <Box className={main}>
        <Box>
          <Typography variant="caption" color="error">
            Payment failed. Please retry.
          </Typography>
        </Box>
      </Box>
      <Box className={containerButton}>
        <CallToAction
          buttonType={"click"}
          isDisabled={isFormSubmitted}
          isFormSubmitted={isFormSubmitted}
          text={"Retry Payment"}
          handleClick={handleRetryPayment}
        />
      </Box>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowPaymentFailed);
